import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { colors } from '../styles';

const styles = css`
padding:60px 0;
.PageSection_alternate {
  .row {
    margin-bottom: 60px;
  }
  .headline {
    color:${colors.color2};
    font-weight:700;
    margin-bottom:20px;
  }
  .result-media {
    height: 100%;
    cursor: pointer;
    width: auto;
    background-size: cover;
    background-repeat: no-repeat;

  }
  ul {
    list-style-type: none;
    padding: 0 0 30px;

    li {
      list-style-type: none;
      padding: 5px 0;
      border-bottom: 1px solid ${colors.whiteDarker};
      font-weight: 300;
    }

    li:last-child {
      border: 0;
    }

    li:before {
      font-family: "arial", sans-serif;
      content: '\\25AA';
      color: ${colors.color1};
      padding-right: 5px;
      font-size: 20px;
    }
  }
}
`;


function PageSectionsAlternating({ page, collection }) {
  const content = collection || page.page_section;
  return (
    <section className={styles}>
      {
        content.map(item => (
          <div key={item.headline} className="PageSection_alternate">
            <div className="container">
              <div className="row">
                <h3 className="col-12 headline">{item.headline}</h3>
                <div className="col-12" dangerouslySetInnerHTML={SanitizeHtml(get(item, 'text'))} />
              </div>
            </div>
          </div>
        ))
      }
    </section>
  );
}

PageSectionsAlternating.propTypes = {
  page: PropTypes.object,
  collection: PropTypes.arrayOf(PropTypes.object),
};

PageSectionsAlternating.defaultProps = {
  page: undefined,
  collection: undefined,
};


export default PageSectionsAlternating;



// WEBPACK FOOTER //
// ./src/components/PageSectionsAlternatingNoImage.js